export default (el) => {
    let slider = el.parentElement.parentElement.querySelector('.slider-images'),
        target = parseInt(el.getAttribute('data-target')),
        translate = "translateX(-" + target * 100 + "%)",
        buttonTriggered = el.parentElement.querySelector('.btn-slider.triggered');
    buttonTriggered.classList.remove('triggered');
    el.classList.add('triggered');
    slider.style.transform = translate;
}